import { notification } from 'antd'
import { errorCheckbox, successCheckbox, warningCheckbox } from '../assets/svg/checkbox'
import React from 'react'

export const useNotifications = () => {
  const openErrorNotification = (message: React.ReactElement | string) => {
    const messageContent = typeof message === 'string' 
      ? <div style={{ maxWidth: '33.33vw', wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{message}</div>
      : message
    
    notification.open({
      message: messageContent,
      className: 'custom-message-banner error',
      placement: 'bottomRight',
      icon: errorCheckbox,
    })
  }

  const openWarningNotification = (message: React.ReactElement | string) => {
    const messageContent = typeof message === 'string' 
      ? <div style={{ maxWidth: '33.33vw', wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{message}</div>
      : message
    
    notification.open({
      message: messageContent,
      className: 'custom-message-banner warning',
      placement: 'bottomRight',
      icon: warningCheckbox,
    })
  }

  const openSuccessNotification = (message: React.ReactElement | string) => {
    const messageContent = typeof message === 'string' 
      ? <div style={{ maxWidth: '33.33vw', wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{message}</div>
      : message
    
    notification.open({
      message: messageContent,
      className: 'custom-message-banner success',
      placement: 'bottomRight',
      icon: successCheckbox,
    })
  }

  return { openErrorNotification, openWarningNotification, openSuccessNotification }
}
